module.exports = __webpack_public_path__ + "static/footer-afterpay-ea61b56210749c9f79b895966eaa79de.png";